/* eslint-disable vue/no-v-model-argument */
<template>
  <div class="container_info">
    <!-- banner页 -->
    <el-carousel arrow="never" class="banner" indicator-position="none">
      <el-carousel-item v-for="item in advertList" :key="item.id" style="width: 100%; height: 500px">
        <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank">
          <el-image :src="item.imageUrl" style="width: 100%; height: 500px" fit="cover"></el-image>
        </a>
        <el-image v-else :src="item.imageUrl" style="width: 100%; height: 500px" fit="cover"></el-image>
      </el-carousel-item>
    </el-carousel>
    <!-- 主体部分 -->
    <div class="container">
      <div class="tab-img">
        <a class="tab-img-a">
          <img class="tab-zhongnongwang" src="./images/tab_zhongnongwang_1.png" />
        </a>
        <router-link class="tab-img-a" to="/datacenter/zsteel">
          <img class="img_0" src="./images/tab_zhuoganlian_0.png" />
          <img class="img_1" src="./images/tab_zhuoganlian_1.png" />
        </router-link>
        <router-link class="tab-img-a" to="/datacenter/huasuhui">
          <img class="img_0" src="./images/tab_huasuhui_0.png" />
          <img class="img_1" src="./images/tab_huasuhui_1.png" />
        </router-link>
      </div>
      <div class="tab-header">
        <div class="tab-title">
          <div class="tab-title-pinlei">品类：</div>
          <div v-for="(item, index) in cateList" :key="index" class="tab-list">
            <div
              tabindex="1"
              :class="[currentIndex === index ? 'tabItem active' : 'tabItem']"
              @click="clickCate(item, index)"
            >
              {{ item.categoryName || '暂无品类' }}
            </div>
          </div>
        </div>
        <div class="tab-sub-wrap" v-if="currentIndex != 0 && goodsList.length">
          <div class="tabSub">
            <span
              v-for="(item, index) in subCateList"
              :key="index"
              :class="[subIndex === index ? 'tabItem a active' : 'tabItem a']"
              @click="clickSubCate(item, index)"
            >
              {{ item.categoryName }}
            </span>
          </div>
        </div>

        <div class="tab-content">
          <div class="tab-content-header">商品列表</div>
          <img src="@/assets/images/noData.png" class="no_data" v-if="noData" />
          <div class="tab-content-box" v-for="(item, index) in goodsList" :key="index">
            <div class="box-left">
              <img class="tab-content-left" :src="item.imgUrl" />
              <div class="content-main">
                <div class="main-header">{{ item.goodsName }}</div>
                <div class="main-sub">
                  <span>{{ item.categoryName || '暂无品类' }}</span>
                  <div class="main-sub-line">|</div>
                  <span
                    >库存：共{{
                      item.unitName === '吨' ? parseFloat(item.canUseStock || 0).toFixed(2) : item.canUseStock
                    }}{{ item.unitName }}</span
                  >
                </div>
                <div class="main-footer">
                  <img class="main-footer-icon" src="./images/icon_changjia@2x.png" />
                  {{ item.brand || '面议' }}
                </div>
                <div class="main-footer">
                  <img class="main-footer-icon" src="./images/icon_cangku@2x.png" />
                  {{ item.whName || '面议' }}
                </div>
              </div>
            </div>
            <div class="box-right">
              <div class="box-right-price">
                {{ item.negotiable === 'true' || parseInt(item.price) == 0 ? '价格面议' : item.price }}
                <span class="box-right-yuan" v-if="item.negotiable == 'false' && parseInt(item.price) != 0">{{
                  item.priceUnitDesc
                }}</span>
              </div>
              <div class="box-right-sub">价格更新时间：{{ item.lastOnLineDate }}</div>
              <div class="box-right-buy">
                <img class="box-right-buy-icon" src="./images/icon_lainxi@2x.png" />
                <a href="https://mall.ap88.com/#/" target="_blank" style="color: #fff">联系购买</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <div v-if="total > 10" class="totals" style="text-align: center">
      <el-pagination
        v-if="total"
        class="changeEle"
        background
        layout="prev, pager, next"
        :current-page="listParams.currentPage"
        :total="total"
        :page-size="listParams.pageSize"
        @current-change="onCurChange"
      />
    </div>
    <!-- 咨询意向单 -->
    <MessageBoard v-if="showMessageBoard" :isShow="showMessageBoard" @submit="onSubmit" @cancel="onCancel">
    </MessageBoard>
  </div>
</template>
<script>
import {
  getBasicMallGoodsListInfo,
  getOneCategory,
  getTwoCategory,
  getThreeFourCategory,
  intentionInfoAdd,
  getBanner,
  znwCate,
  znwGoods,
} from '@/api';
import MessageBoard from '@/components/MessageBoard';
export default {
  name: 'Peasants',
  components: {
    MessageBoard,
  },
  data() {
    return {
      total: 0,
      noData: false,
      cateList: [
        {
          categoryName: '全部',
          marketCode: '',
        },
        {
          categoryName: '白糖',
          marketCode: '000',
        },
        {
          categoryName: '蚕丝',
          marketCode: '10303',
        },
        {
          categoryName: '饲料',
          marketCode: '12101',
        },
        {
          categoryName: '辣椒',
          marketCode: '10101',
        },
        {
          categoryName: '橡胶',
          marketCode: '11301',
        },
        {
          categoryName: '咖啡',
          marketCode: '11701',
        },
      ],
      subCateList: [],
      goodsList: [],
      listParams: {
        currentPage: 1,
        pageSize: 10,
        categoryCode: '',
        marketCode: '',
      },
      currentIndex: 0,
      subIndex: 0,
      dialogVisible: false,
      advertList: [],
      tab: '000', // 选项卡 默认选中000
      dataList: [],
      peasantList: [], // 一级类目名称
      categoryList: [], // 二级类目名称不展示
      varietyList: [], // 三级类目 榨季
      childInfo: [], // 三级类目 等级
      current: 0,
      categoryName: '', // 类目名称
      total: 0,
      page: 1,
      rows: 10,

      marketCode: '',
      limeStatus: '',
      cateValue: {
        categoryName: '全部分类',
        cateCode: '',
      },
      industry: '',
      industryName: '',
      category: '',
      orderData: {}, // 订单数据
      boardData: {}, // 留言数据
      showMessageBoard: false,
      disabled: false,
      params: {
        marketCode: '000', // 类目表一级菜单code , 白糖：market_code = '000' ，茧丝：market_code = 10303'
        lineStatus: 'onLine',
        crushingSeason: '', // 榨季(选择全部， 该字段传空)
        grade: '', // 等级(选择全部， 该字段传空)
        category: '', // 交货方式(选择全部， 该字段传空)
        // varietyCode: '', // 二级菜单code
        price: '',
      },
    };
  },
  beforeMount() {},
  created() {
    // 列表接口
    // this.getBasicMallGoodsListInfo();
    // //  一类目
    // this.getRow();
    this.getBannerList();
    this.getList();
    this.tabcade = '000';
  },
  methods: {
    async getCate(marketCode, name) {
      const ret = await znwCate({
        marketCode,
      });
      if (ret.code === 100000) {
        ret.data.unshift({
          categoryName: '全部' + name,
          categoryCode: '',
        });
        this.subCateList = ret.data;
      }
    },
    async getList() {
      this.loading = true;
      const ret = await znwGoods(this.listParams);
      this.loading = false;
      this.total = ret.data.total;
      if (ret.code === 100000) {
        this.goodsList = ret.data.rows;
        this.noData = this.goodsList.length ? false : true;
      }
    },
    clickCate(item, index) {
      this.currentIndex = index;
      this.listParams.marketCode = item.marketCode;
      this.listParams.categoryCode = '';
      this.listParams.currentPage = 1;
      this.subIndex = 0;
      if (item.marketCode) {
        this.getCate(item.marketCode, item.categoryName);
      }
      this.getList(item.categoryCode);
    },
    clickSubCate(item, index) {
      this.subIndex = index;
      this.listParams.categoryCode = item.categoryCode;
      this.listParams.currentPage = 1;
      this.getList();
    },
    onCurChange(curPage) {
      this.listParams.currentPage = curPage;
      this.getList();
      document.body.scrollTop = document.documentElement.scrollTop = 560;
    },
    // eslint-disable-next-line vue/no-dupe-keys
    click(index) {
      this.currentIndex = index;
    },
    subClick(index) {
      this.subIndex = index;
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    tabcateCode(cateCode, industry) {
      console.log(cateCode);
      this.tab = cateCode;
      this.industry = cateCode;
      this.params.crushingSeason = '';
      this.params.grade = '';
      this.params.jhType = '';
      this.params.price = '';
      this.params.category = '';
      if (this.industry) {
        this.disabled = true;
        // eslint-disable-next-line no-undef
        getTwoCategory({ pl_code: 'znw', p_code: cateCode }).then((res) => {
          if (res.status) {
            this.categoryList = res.data;
            console.log(this.categoryList.length);
            // eslint-disable-next-line no-debugger
            // debugger;
            if (this.categoryList.length > 0) {
              this.getRowThr(this.categoryList[0].cateCode);
              // eslint-disable-next-line no-eq-null
            } else {
              this.categoryList = [];
              this.varietyList = [];
              this.getBasicMallGoodsListInfo();
            }
          } else {
            this.$message.error(this.$t(`error.${res.errorCode}`));
          }
        });
        // eslint-disable-next-line no-constant-condition
      }
      // 列表接口
      this.getBasicMallGoodsListInfo();
    },
    getBannerList() {
      let postData = { page: 1, path: 'platform', uc_to: '' };
      getBanner(postData).then((res) => {
        console.log(res);
        if (res.status) {
          let { content } = res.data;
          if (Array.isArray(content) && content.length) {
            let [, , banner] = content[0];
            if (banner && typeof banner.data === 'object') {
              let { advertList } = banner.data;
              this.advertList = Array.isArray(advertList) ? advertList : [];
            }
          }
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },

    changeTab(code) {
      this.tab = code;
      this.getRowTwo(code);
    },

    /**
     * 查询一级类目
     * pl_code	T文本	是 平台code 卓钢链:zgl 中农网:znw
     */
    getRow(cateCod, categoryName) {
      getOneCategory({ pl_code: 'znw' }).then((res) => {
        if (res.status) {
          this.peasantList = res.data;
          // this.peasantList.reverse();
          this.getRowTwo(this.peasantList[0].cateCode);
        } else {
          this.$message.error(this.$t(`error.${res.errorCode}`));
        }
      });
    },
    /**
     * 查询二级类目  目前暂且只可查询白糖
     * pl_code	T文本	是 平台code 卓钢链:zgl 中农网:znw
     * p_code   T文本	是 父类目code
     */
    getRowTwo(cateCode) {
      // 定义数组 二类 三四类类目
      this.industry = cateCode;
      console.log(this.industry);
      if (this.industry) {
        this.disabled = true;
        // eslint-disable-next-line no-undef
        getTwoCategory({ pl_code: 'znw', p_code: cateCode }).then((res) => {
          if (res.status) {
            this.categoryList = res.data;
            this.getRowThr(this.categoryList[0].cateCode);
          } else {
            this.$message.error(this.$t(`error.${res.errorCode}`));
          }
        });
      } else if (this.industry == 20) {
        this.disabled = false;
        return false;
      }
    },
    /**
     * code 三级类目 cateCode
     * cat  四级类目
     */
    pickCategory(index, idx) {
      // eslint-disable-next-line no-return-assign
      this.varietyList[index].child.map((lst) => (lst.checked = false));
      this.varietyList[index].child[idx].checked = !this.varietyList[index].child[idx].checked;
      if (this.varietyList[index].cateCode === '10100001') {
        this.params.crushingSeason = this.varietyList[index].child[idx].cateCode;
        this.getBasicMallGoodsListInfo();
      } else if (this.varietyList[index].cateCode === '10100002') {
        this.params.grade = this.varietyList[index].child[idx].cateCode;
        this.getBasicMallGoodsListInfo();
      } else if (this.varietyList[index].cateCode === '10100003') {
        this.params.jhType = this.varietyList[index].child[idx].cateCode;
        this.getBasicMallGoodsListInfo();
      } else if (this.varietyList[index].cateCode === '20300001') {
        this.params.category = this.varietyList[index].child[idx].cateCode;
        this.getBasicMallGoodsListInfo();
      } else if (this.varietyList[index].cateCode === '20300002') {
        this.params.price = this.varietyList[index].child[idx].cateCode;
        this.getBasicMallGoodsListInfo();
      }
      this.$forceUpdate();
    },

    // eslint-disable-next-line no-undef
    //   getTwoCategory({ pl_code: 'znw', p_code: cateCode }).then((res) => {
    //     if (res.status) {
    //       this.categoryList = res.data;
    //       // this.getRowThr(this.categoryList[0].cateCode, () => {
    //       //   this.getBasicMallGoodsListInfo(this.varietyList[0].cateCode);
    //       // });

    //       this.getBasicMallGoodsListInfo();
    //     } else {
    //       this.$message.error(this.$t(`error.${res.errorCode}`));
    //     }
    //   });
    // },
    /**
     * 查询三四级类目  目前暂且只可查询白糖
     * pl_code	T文本	是 平台code 卓钢链:zgl 中农网:znw
     * p_code   T文本	是 父类目code
     */
    getRowThr(cateCode) {
      // eslint-disable-next-line no-undef
      getThreeFourCategory({ p_code: cateCode, pl_code: 'znw' }).then((res) => {
        if (res.status) {
          // 不同的方式
          this.varietyList = res.data;
          // eslint-disable-next-line no-return-assign
          this.varietyList.map((item) => item.child.map((lst) => (lst.checked = false)));

          // 调取列表接口查询
          this.getBasicMallGoodsListInfo();
        } else {
          this.$message.error(this.$t(`error.${res.errorCode}`));
        }
      });
    },

    /**
      * 查询新闻列表接口
      * page	T文本	是 页数
        rows  T文本 是 每页大小
        marketCode	T文本	是 白糖：market_code = '000' ，茧丝：market_code = 10303'
        lineStatus	T文本	是 line_status = 'onLine'
    */
    // 列表接口
    // eslint-disable-next-line max-params
    getBasicMallGoodsListInfo(page, cat, code) {
      let { lineStatus, crushingSeason, grade, jhType, price, category } = this.params;
      const params = {
        page: this.page,
        rows: 10,
        marketCode: this.tab,
        lineStatus,
        crushingSeason,
        grade,
        jhType,
        price,
        category,
      };
      // eslint-disable-next-line no-unused-vars
      getBasicMallGoodsListInfo(params).then((res) => {
        if (res.status) {
          this.dataList = res.data.rows.map((item) => {
            return item;
          });
          this.total = res.data.total;
        } else {
          this.$message.error(this.$t(`error.${res.errorCode}`));
          this.dataList = [];
          this.total = 0;
        }
      });
    },
    // 质询意向单接口
    intentionInfoAdd() {
      /**
       * let postData = {
       *   cn: '联系人',
       *   ph: '联系人手机号码',
       *   pf: '平台1卓钢链 2中农 3化塑汇',
       *   pc: '商品code',
       *   pn: '名称（根据平台不同，名称由各个平台的商品不同属性组合而成，逗号拼接）',
       *   mk: '备注',
       * };
       */
      let { name: cn, tel: ph, remark: mk } = this.boardData;
      let { code: pc, name, crushingSeason } = this.orderData;
      let postData = { cn, ph, pf: 2, pc, pn: name + ', ' + crushingSeason, mk };
      intentionInfoAdd(postData).then((res) => {
        if (res.status) {
          this.showMessageBoard = false;
          this.$message.success('咨询意向单提交成功');
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    // 提交意向单
    onSubmit(val) {
      this.boardData = val;
      this.intentionInfoAdd();
    },
    // 咨询意向单关闭
    onCancel() {
      this.showMessageBoard = false;
    },
    // 提交意向单弹窗
    onBuy(order) {
      this.showMessageBoard = true;
      this.orderData = order;
    },
    // 清空数据 展示全部
    reset() {
      this.params.crushingSeason = '';
      this.params.grade = '';
      this.params.jhType = '';
      // eslint-disable-next-line no-return-assign
      this.varietyList.map((item) => item.child.map((lst) => (lst.checked = false)));
      // 调取列表接口查询
      this.getBasicMallGoodsListInfo();
    },
    handleCurrentChange(val) {
      console.log(val);
      this.page = val;
      // 调取列表接口查询
      this.getBasicMallGoodsListInfo();
      document.body.scrollTop = document.documentElement.scrollTop = 560;
    },
  },
};
</script>
<style lang="scss" scoped>
.banner {
  width: 100%;
  min-width: 1180px;
  height: 500px;

  ::v-deep .el-carousel__container {
    width: 100%;
    height: 100%;
  }

  .el-image {
    width: 100%;
    height: 500px;
  }
}

.actives {
  font-weight: 600;
  color: #0174ff;
}

.container_info {
  .carousel {
    width: 100%;
    height: 500px;
    background: url(./images/carousel.png) no-repeat center center;
    background-size: 100%;
  }

  .container {
    margin-top: 24px;

    .words_router {
      width: 93px;
      height: 20px;
      padding: 20px 0;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      color: #333;
    }

    .tabs_info {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-end;
      height: 55px;
      padding-left: 170px;
      background: rgba(179, 203, 243, 0.32);

      p {
        width: 96px;
        height: 50px;
        font-size: 16px;
        line-height: 50px;
        text-align: center;
        cursor: pointer;

        &.active {
          margin-top: 5px;
          margin-right: 10px;
          font-weight: bold;
          color: #0174ff;
          background: #fff;
        }
      }
    }

    .roductname {
      width: 100%;
      height: 93px;
      background: #fff;
      border-top: 1px solid #eee;
      border-right: 1px solid #eee;
      border-bottom: 1px solid #eee;
      border-left: 1px solid #eee;

      .roduct {
        float: left;
        width: 80px;
        height: 24px;
        padding: 15px 30px 54px 34px;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        color: #333;
      }

      .nav {
        display: flex;
        flex-wrap: wrap;

        .item {
          margin-top: 15px;
          margin-right: 50px;
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          color: #333;
          cursor: pointer;

          // &:hover {
          //   font-weight: 600;
          //   color: #0174ff;
          // }
          // &.active {
          //   font-weight: 600;
          //   color: #0174ff;
          // }
        }
      }
    }

    .roductname_info {
      box-sizing: border-box;
      width: 100%;
      background: #fff;
      border-right: 1px solid #eee;
      border-bottom: 1px solid #eee;
      border-left: 1px solid #eee;

      .roduct {
        float: left;
        width: 80px;
        height: 24px;
        padding: 15px 30px 15px 34px;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        color: #333;
      }
    }

    .roductname_info-item {
      display: flex;
      padding-top: 15px;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      color: #333;
      cursor: pointer;
      border-bottom: 1px solid #eaeaea;
    }

    .leftlist {
      width: 80px;
      padding-left: 30px;
    }

    .variety {
      display: flex;
      flex: 1;
      flex-wrap: wrap;
    }

    .variety-item {
      margin-bottom: 15px;
      margin-left: 50px;
    }

    .roductname_info:last-child {
      border-top: none;
      border-bottom: none;
    }

    .content {
      width: 100%;
      height: 40px;
      margin-top: 20px;
      background: #fff;
      border-bottom: 1px solid #eaeaea;

      &-left {
        float: left;
        width: 44px;
        height: 30px;
        font-size: 22px;
        font-weight: 600;
        line-height: 30px;
        color: #333;
      }

      &-right {
        position: relative;
        right: -26px;
        float: right;
        width: 136px;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: #0076ff;
      }
    }

    .content_list {
      box-sizing: border-box;
      display: flex;

      .list_name {
        flex: 1;

        .words_list {
          position: relative;
          display: flex;
          height: auto;
          min-height: 130px;
          margin-top: 20px;
          overflow: hidden;
          background: #fff;
          border: 1px solid #eaeaea;
          border-radius: 4px;

          &:hover {
            box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.1), 0 -4px 5px 0 rgba(0, 0, 0, 0.1);
          }

          &::before {
            position: absolute;
            top: 0;
            width: 4px;
            height: 100%;
            content: ' ';
            background: #7996f5;
          }

          .left {
            float: left;
            width: 820px;
            min-height: 70px;
            margin-left: 14px;
            text-align: justify;
            text-justify: newspaper;
            word-break: break-all;

            .product {
              height: 20px;
              padding-right: 8px;
              margin-top: 10px;
              margin-bottom: 10px;
              font-size: 16px;
              font-weight: 600;
              line-height: 20px;
              color: #333;

              &:hover {
                color: #7996f5;
              }
            }

            .diviver {
              position: relative;
              top: 2px;
              display: inline-block;
              width: 2px;
              height: 16px;
              background: #333;
            }
          }

          .season {
            float: right;
            width: 50px;
            height: 100%;
            padding-left: 10px;
            margin-top: 0;
            margin-left: 10px;
            font-size: 15px;
            font-weight: 600;
            color: #333;
            border-left: 2px solid #333;
          }

          .left_bottom {
            margin-top: 10px;

            img {
              display: block;
              width: 14px;
              height: 14px;
            }

            .city {
              position: absolute;
              width: auto;
              min-width: 30px;
              height: 17px;
              margin-top: -14px;
              margin-right: 10px;
              margin-left: 2px;
              margin-left: 20px;
              font-size: 12px;
              font-weight: 400;
              line-height: 17px;
              color: #2eb6aa;
            }

            .citys {
              margin-top: -17px;
              margin-left: 53px;

              .divive {
                width: 2px;
                height: 17px;
                background: #eaeaea;
              }

              .city_info {
                position: absolute;
                display: flex;
                justify-content: center;
                width: auto;
                min-width: 54px;
                max-width: 545px;
                height: 20px;
                margin-top: -17px;
                margin-left: 10px;
                font-size: 14px;
                font-weight: 400;
                color: #333;
              }
            }
          }

          .right {
            float: right;
          }
        }
      }
    }

    .tab-img {
      display: flex;

      .tab-img-a {
        display: flex;
        border: 1.5px dotted #ececec;
        margin-right: 8px;
        cursor: pointer !important;

        .img_1 {
          display: none;
        }

        .tab-zhongnongwang {
          border: 1.5px dotted #7f97ee;
          box-shadow: 0px 2px 6px 0px rgba(127, 151, 238, 0.5);
        }
      }

      .tab-img-a:focus {
        border: 1.5px dotted #7f97ee;
        box-shadow: 0px 2px 6px 0px rgba(127, 151, 238, 0.5);
      }

      .tab-img-a:hover {
        border: 1.5px dotted #7f97ee;
        box-shadow: 0px 2px 6px 0px rgba(127, 151, 238, 0.5);
        cursor: default;
      }

      .tab-img-a:focus .img_1,
      .tab-img-a:hover .img_1 {
        display: block;
      }

      .tab-img-a:hover .img_0 {
        display: none;
      }

      .tab-img-a:focus .img_0 {
        display: none;
      }

      .tab-huasuhui {
        border: 1.5px dotted #7f97ee;
        box-shadow: 0px 2px 6px 0px rgba(127, 151, 238, 0.5);
      }
    }
  }

  .info-bottom {
    position: absolute;
    bottom: 10px;
    width: 85%;
    height: 40px;
    padding-left: 10px;
    line-height: 40px;
    background: #f7fafd;

    .name {
      margin-left: 30px;
      color: #81899e;

      &:nth-child(1) {
        margin-left: 0;
      }
    }
  }

  .info-top-right {
    position: absolute;
    right: 142px;
    height: 72px;
    margin-right: 20px;
    line-height: 72px;

    .price {
      font-size: 18px;
      color: #f7b500;
    }
  }

  .ope_right {
    position: absolute;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 140px;
    height: 110px;
    margin-top: 10px;
    box-shadow: -1px 0 0 0 #e9ebf0;

    .contact {
      width: 120px;
      height: 38px;
      line-height: 38px;
      color: #fff;
      text-align: center;
      background: #7996f5;
      border-radius: 2px;
    }
  }

  .totals {
    margin-top: 20px;
    margin-bottom: 30px;
  }

  .tab-header {
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    font-size: 16px;
    cursor: default;
    padding-top: 21px;

    .tab-sub-wrap {
      padding-left: 80px;
    }

    .tabItem {
      padding: 0 0 12px 32px;
      box-sizing: border-box;
      font-weight: 400;
      color: rgba(102, 102, 102, 0.8);
      position: relative;
      cursor: pointer;
      font-size: 16px;

      &.active {
        font-weight: bold;
        color: #4870ff;
      }
    }

    .tabItem.a {
      font-size: 14px;

      &.active {
        font-size: 14px;
      }
    }

    .tabSub {
      display: flex;
      background: rgba(127, 151, 238, 0.08);
      padding: 11px 0 0 0;

      .tabSubTitle {
        padding-right: 32px;
        display: none;
        font-weight: 400;
        color: rgba(102, 102, 102, 0.6);
        font-size: 14px;
        padding: 10px 0px 10px 32px;

        cursor: pointer;
        // &.active {
        //   font-weight: bold;
        //   color: #4870FF;
        // }
      }

      .tabSubTitle:hover {
        font-weight: bold;
        color: #4870ff;
      }

      .tabSubTitle:focus {
        font-weight: bold;
        color: #4870ff;
      }
    }

    .tab-title {
      display: flex;
      align-content: center;

      .tab-title-pinlei {
        font-weight: bold;
        color: #666666;
      }

      .tab-list {
        display: flex;
        flex-direction: column;

        .tabItem:focus {
          font-weight: bold;
          color: #4870ff;
        }

        .tabItem:hover {
          font-weight: bold;
          color: #4870ff;
        }
      }

      .tab-list:hover .tabSub .tabSubTitle {
        display: block;
      }

      .tab-list:focus .tabSub .tabSubTitle {
        display: block;
      }
    }

    .tab-content {
      padding-top: 32px;
      border-top: 1px solid #ececec;
      margin-top: 24px;

      .tab-content-header {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
        padding-bottom: 8px;
      }

      .tab-content-box {
        border: 1px solid #ececec;
        padding: 32px 24px;
        margin-bottom: 8px;
        display: flex;
        justify-content: space-between;
        align-content: center;

        .box-left {
          display: flex;
          align-items: center;

          .tab-content-left {
            width: 120px;
            height: 120px;
          }

          .content-main {
            padding-left: 15px;
            font-size: 14px;
            font-weight: 400;
            line-height: 30px;

            .main-header {
              font-weight: bold;
              color: #333333;
              font-size: 20px;
            }

            .main-sub {
              color: #666666;
              display: flex;

              .main-sub-line {
                margin: 0 16px;
                color: #999999;
                widows: 1px;
              }
            }

            .main-footer {
              color: #7f97ee;
              display: flex;
              align-items: center;

              .main-footer-icon {
                width: 14px;
                height: 14px;
                margin-right: 8px;
              }
            }
          }
        }

        .box-right {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-weight: bold;
          color: #ffa42a;
          line-height: 24px;
          font-size: 20px;

          .box-right-price {
            font-weight: bold;
            color: #ffa42a;
            font-size: 24px;

            .box-right-yuan {
              font-weight: 400;
              color: #ffa42a;
              font-size: 16px;
            }
          }

          .box-right-sub {
            font-weight: 400;
            color: #999999;
            font-size: 13px;
          }

          .box-right-buy {
            background: #7f97ee;
            border-radius: 2px;
            padding: 10px 40px;
            margin-top: 10px;
            font-weight: 400;
            color: #ffffff;
            font-size: 14px;
            cursor: pointer;
            display: flex;
            align-items: center;
            .el-icon-shopping-cart-full {
              font-size: 16px;
              padding-right: 8px;
            }

            .box-right-buy-icon {
              width: 16px;
              height: 15px;
              margin-right: 8px;
            }
          }
        }
      }
    }
  }
}

.loading {
  font-size: 48px;
}

.roductname_list-nav {
  position: absolute;
  left: 250px;
  height: 55px;
  margin-top: -195px;
}

// .words_list:hover {
//   box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.1), 0 -4px 5px 0 rgba(0, 0, 0, 0.1);
//   .product {
//     color: #7996f5;
//   }
// }
/deep/.el-dialog__body {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 54px 0 69px 0;
  border-top: 1px solid #ececec;
  border-bottom: 1px solid #ececec;

  .dialog-content {
    display: flex;
    align-items: center;
    padding-bottom: 12px;

    .dialog-img {
      width: 24px;
      height: 24px;
    }

    .dialog-title {
      font-weight: 400;
      color: #333333;
      font-size: 16px;
      padding-left: 12px;
    }
  }

  .dialog-tel {
    font-weight: 400;
    color: #7f97ee;
    font-size: 20px;
  }

  .dialog-line {
    height: 64px;
  }
}

/deep/ .el-dialog__header {
  font-weight: bold;
  color: #333333;
  font-size: 16px;
  padding: 17px 24px;
}

/deep/.el-dialog__headerbtn .el-dialog__close {
  font-size: 20px;
}

/deep/ .el-dialog__footer {
  padding: 12px 24px;
}

/deep/ .el-button {
  border-radius: 2px;
  padding: 9px 28px;
}
</style>
